import FormWidget from "../form-widget.js";

class RatingGradingWidget extends FormWidget {
    public override process() {
        const fieldEl = this.element as HTMLInputElement;

        let minValue = parseInt(fieldEl.getAttribute('min') ?? '0');
        let maxValue = parseInt(fieldEl.getAttribute('max') ?? '0');
        let step = parseInt(fieldEl.getAttribute('step') ?? '1');
        const widgetType = this.config?.identifier.toLowerCase() ?? 'rating';

        if(minValue < 1) {
            minValue = 1;
        }

        const widgetContainerEl = document.createElement('div');
        widgetContainerEl.setAttribute('class', 'widget-' + widgetType);
        fieldEl.after(widgetContainerEl);
        fieldEl.style.display = 'none';

        const optionsEl: HTMLElement = document.createElement('div');
        optionsEl.setAttribute('class', 'options');
        widgetContainerEl.append(optionsEl);

        const optionMap = new Map<HTMLElement, number>();

        const updateVisual = function(value: number) {
            if(optionsEl.childElementCount > 0) {
                optionMap.forEach((optionValue: number, el: HTMLElement) => {
                    el.classList.remove('inrange');
                    el.classList.remove('checked');
                    if(value > 0) {
                        if(widgetType == 'rating' && value >= optionValue) {
                            el.classList.add('inrange');
                        }
                        if(optionValue === value) {
                            el.classList.add('checked');
                        }
                    }
                });
            }
        };

        for(let i = minValue; i <= maxValue; i+=step) {
            let content = '<span class="icon bi bi-star icon-xl"></span>';
            if(widgetType == 'grading') {
                content = '<span class="label">'+i+'</span>';
            }
            let optionEl: HTMLElement = document.createElement('span');
            optionEl.setAttribute('class', 'option');
            optionEl.innerHTML = content;
            optionEl.addEventListener('click', (ev: MouseEvent) => {
                fieldEl.value = i.toString();
                updateVisual(i);
            });

            optionMap.set(optionEl, i);

            if(widgetType == 'rating') {
                optionEl.addEventListener('mouseover', (ev: MouseEvent) => {
                    updateVisual(i)
                });
                optionEl.addEventListener('mouseout', (ev: MouseEvent) => {
                    updateVisual(parseInt(fieldEl.value))
                });
            }
            optionsEl.append(optionEl);

        }

        updateVisual(parseInt(fieldEl.value));
    }

}

export default RatingGradingWidget;
